import { RecordKind } from './record.js';
import { optionIdSymbol, sourcesSymbol, typeSymbol } from './engine-impl.js';
export function pModelTypeGuard(value) {
    return typeof (value) === 'object' && '_id' in value && typeSymbol in value && optionIdSymbol in value;
}
export function pOptionTypeGuard(value) {
    return typeof (value) === 'object' && '_id' in value && value.kind === RecordKind.Option;
}
export class ValidationResult {
    constructor(valid, message) {
        this.valid = valid;
        this.message = message;
    }
    get isValid() {
        return this.valid;
    }
    get isInvalid() {
        return !this.valid;
    }
    get errorMessage() {
        return this.message;
    }
    static Error(message) {
        return new ValidationResult(false, message);
    }
    static Valid() {
        return new ValidationResult(true, '');
    }
    and(next) {
        return this.isInvalid ? this : next();
    }
}
//# sourceMappingURL=engine.js.map